import { render } from "./ATable.vue?vue&type=template&id=0f3cc8f9"
import script from "./ATable.vue?vue&type=script&lang=js"
export * from "./ATable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__